import { render, staticRenderFns } from "./ResponsiblePerson.vue?vue&type=template&id=342159f2&scoped=true"
import script from "./ResponsiblePerson.vue?vue&type=script&lang=js"
export * from "./ResponsiblePerson.vue?vue&type=script&lang=js"
import style0 from "./ResponsiblePerson.vue?vue&type=style&index=0&id=342159f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342159f2",
  null
  
)

export default component.exports